import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ['form']
  }

  keydown(e) {
    if (!(e.keyCode == 13 && (e.metaKey || e.ctrlKey))) return;
    e.preventDefault();
    this.formTarget.requestSubmit();
  }
}